import { Link, useLocation} from "react-router-dom";
import { ArrowBackIcon } from "./Icons";
import React, { useState, useEffect, useRef } from 'react';
import Typed from 'typed.js';
import "./../AppMathMode.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {getAttendance, getTalks} from './updatables';
import { useMediaQuery } from 'react-responsive';

const ConferencesMathMode = ({page}) => {
    const isSmallScreen = useMediaQuery({ maxWidth: 670 });

    const [attendance, setAttendance] = React.useState([]);
    const [talks, setTalks] = React.useState([]);
    
    React.useEffect(() => {
        async function loadAttendance() {
            const data = await getAttendance();
            setAttendance(data);
        }
  
        loadAttendance();
    }, []);

    React.useEffect(() => {
        async function loadTalks() {
            const data = await getTalks();
            setTalks(data);
        }
  
        loadTalks();
    }, []);

    return <div class="body" style={{height: "auto", width: "100%", position: "relative", backgroundSize: "cover", color: "black", backgroundPosition: "center", zIndex: 0, display: "inline-block", justifyContent: "space-between", padding: "16px", margin: "0px"}}>
        Talks & Posters:
        <ul style={{paddingTop: "16px"}}>
        {talks.map((item, index) => (
            <li
            key={index}
            style={{
                fontFamily: "Garamond, serif",
                fontSize: "22px",
                paddingBottom: "8px",
            }}
            >
            <span style={{textDecoration: "underline", fontFamily: "Garamond, serif"}}>{item.title}</span> ({item.type}), {item.conference}, {item.date}
            </li>
        ))}
        </ul>
        Attendance:
        <ul>
        {attendance.map((item, index) => (
            <li
            key={index}
            style={{
                fontFamily: "Garamond, serif",
                fontSize: "22px",
                paddingBottom: "8px"
            }}
            >
            <span style={{textDecoration: "underline", fontFamily: "Garamond, serif"}}>{item.conference}</span>, {item.date}, {item.location}
            </li>
        ))}
        </ul>
    </div>;
};

export default ConferencesMathMode;